"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataMultiplierController = (function () {
    function DataMultiplierController(multipliers) {
        this._multipliers = multipliers;
    }
    DataMultiplierController.prototype.generateDataMultiplierPromises = function (basePlan) {
        var newPlans = [];
        this._multipliers.forEach(function (multiplier) {
            var planWithMultiplier = DataMultiplierController.createPlanWithMultiplier(basePlan, multiplier);
            newPlans.push(planWithMultiplier);
        });
        return newPlans;
    };
    DataMultiplierController.createPlanWithMultiplier = function (originalPlan, dataMultiplier) {
        var newPlan = _.cloneDeep(originalPlan);
        newPlan.plan.placements.forEach(function (placement) {
            _.set(placement, "dataMultiplier", dataMultiplier);
        });
        return newPlan;
    };
    DataMultiplierController.prototype.retrieveDataFromMultiplierPlans = function (multiplierPlanResults, field, outputNamePrefix) {
        var results = [];
        multiplierPlanResults.forEach(function (multiplierPlanResult, multiplierPlanIndex) {
            if (!multiplierPlanResult.groupDetails) {
                return {};
            }
            multiplierPlanResult.groupDetails.forEach(function (group) {
                group.media.forEach(function (medium) {
                    medium.placements.forEach(function (placement) {
                        results.push(DataMultiplierController.compileResultsObject(outputNamePrefix, multiplierPlanIndex, placement, field));
                    });
                });
            });
        });
        var resultsGrouped = _.groupBy(results, "tag");
        return resultsGrouped;
    };
    DataMultiplierController.compileResultsObject = function (outputNamePrefix, multiplierIndex, placement, field) {
        var planTag = outputNamePrefix + multiplierIndex;
        var tag = placement.tag;
        var value = _.get(placement, field);
        return { plan: planTag, tag: tag, value: value };
    };
    return DataMultiplierController;
}());
exports.DataMultiplierController = DataMultiplierController;
//# sourceMappingURL=dataMultiplierController.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/dataMultiplierController.js
// module id = 49
// module chunks = 0